import React, { useState } from 'react';
import './DeferredEducationalContent.css';

const DeferredEducationalContent = () => {
  const [expandedSection, setExpandedSection] = useState(null);

  const toggleSection = (section) => {
    if (expandedSection === section) {
      setExpandedSection(null);
    } else {
      setExpandedSection(section);
    }
  };

  return (
    <div className="deferred-educational-content">
      <h4>Understanding Deferred FERS Retirement</h4>
      
      <div className="info-card">
        <div 
          className={`info-header ${expandedSection === 'eligibility' ? 'expanded' : ''}`}
          onClick={() => toggleSection('eligibility')}
        >
          <span className="info-title">Eligibility Requirements</span>
          <span className="toggle-icon">{expandedSection === 'eligibility' ? '−' : '+'}</span>
        </div>
        
        {expandedSection === 'eligibility' && (
          <div className="info-content">
            <p>To be eligible for a deferred FERS retirement benefit, you must:</p>
            <ul>
              <li>Have completed at least 5 years of creditable civilian service</li>
              <li>Have left federal service before qualifying for an immediate retirement</li>
              <li>Not have withdrawn your retirement contributions</li>
            </ul>
            <p>Your deferred annuity can begin as early as:</p>
            <ul>
              <li><strong>MRA (57-60):</strong> If you have 10+ years of service (with age reduction)</li>
              <li><strong>Age 60:</strong> If you have 20+ years of service</li>
              <li><strong>Age 62:</strong> If you have 5+ years of service</li>
            </ul>
          </div>
        )}
      </div>

      <div className="info-card">
        <div 
          className={`info-header ${expandedSection === 'calculation' ? 'expanded' : ''}`}
          onClick={() => toggleSection('calculation')}
        >
          <span className="info-title">How Benefits Are Calculated</span>
          <span className="toggle-icon">{expandedSection === 'calculation' ? '−' : '+'}</span>
        </div>
        
        {expandedSection === 'calculation' && (
          <div className="info-content">
            <p>Your FERS deferred annuity is calculated using the standard formula:</p>
            <div className="formula">
              <strong>1% × High-3 Salary × Years of Service</strong>
            </div>
            <p>Important factors:</p>
            <ul>
              <li><strong>High-3 Salary:</strong> Average of your highest 3 consecutive years of basic pay at separation (not adjusted for inflation)</li>
              <li><strong>Years of Service:</strong> Total creditable service at the time you left federal employment</li>
              <li><strong>Age Reduction:</strong> If starting benefits before age 62, your benefit is reduced by 5% for each year you are under age 62 (or age 60 with 20+ years)</li>
              <li><strong>No FERS Supplement:</strong> Deferred retirees are not eligible for the FERS Supplement</li>
            </ul>
          </div>
        )}
      </div>

      <div className="info-card">
        <div 
          className={`info-header ${expandedSection === 'differences' ? 'expanded' : ''}`}
          onClick={() => toggleSection('differences')}
        >
          <span className="info-title">Deferred vs. Immediate Retirement</span>
          <span className="toggle-icon">{expandedSection === 'differences' ? '−' : '+'}</span>
        </div>
        
        {expandedSection === 'differences' && (
          <div className="info-content">
            <p>Key differences between deferred and immediate retirement:</p>
            <table className="comparison-table">
              <thead>
                <tr>
                  <th>Feature</th>
                  <th>Deferred Retirement</th>
                  <th>Immediate Retirement</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>FERS Supplement</td>
                  <td>Not eligible</td>
                  <td>Eligible until age 62</td>
                </tr>
                <tr>
                  <td>Sick Leave</td>
                  <td>Not credited</td>
                  <td>Credited toward service time</td>
                </tr>
                <tr>
                  <td>FEHB/FEGLI</td>
                  <td>Not continued</td>
                  <td>Can continue with 5+ years coverage</td>
                </tr>
                <tr>
                  <td>COLAs</td>
                  <td>Only after age 62</td>
                  <td>Begins with retirement</td>
                </tr>
                <tr>
                  <td>TSP</td>
                  <td>Can leave in TSP or roll over</td>
                  <td>Full access at retirement</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div className="info-card">
        <div 
          className={`info-header ${expandedSection === 'resources' ? 'expanded' : ''}`}
          onClick={() => toggleSection('resources')}
        >
          <span className="info-title">Official Resources</span>
          <span className="toggle-icon">{expandedSection === 'resources' ? '−' : '+'}</span>
        </div>
        
        {expandedSection === 'resources' && (
          <div className="info-content">
            <p>For official information on deferred retirement, consult these resources:</p>
            <ul className="resources-list">
              <li>
                <a href="https://www.opm.gov/retirement-services/fers-information/" target="_blank" rel="noopener noreferrer">
                  OPM FERS Information
                </a>
              </li>
              <li>
                <a href="https://www.opm.gov/retirement-services/publications-forms/pamphlets/ri92-19a.pdf" target="_blank" rel="noopener noreferrer">
                  FERS Retirement Guide (PDF)
                </a>
              </li>
              <li>
                <a href="https://www.opm.gov/retirement-services/calculators/" target="_blank" rel="noopener noreferrer">
                  OPM Retirement Calculators
                </a>
              </li>
              <li>
                <a href="https://www.tsp.gov/publications/tspbk08.pdf" target="_blank" rel="noopener noreferrer">
                  TSP Withdrawal Options (PDF)
                </a>
              </li>
            </ul>
          </div>
        )}
      </div>
      
      <div className="disclaimer">
        This information is provided as general guidance. For official determinations, always consult 
        with your HR department or the Office of Personnel Management (OPM).
      </div>
    </div>
  );
};

export default DeferredEducationalContent;
